import React from 'react'
import CSSModules from "lib/utils/css-modules"
import styles from "./IntegrationLogRow.less"

@CSSModules(styles)
export default class IntegrationLogRow extends React.PureComponent {
  
    render(){
        const { data, changeIntegrationLogId } = this.props
        const { id, companyId, dateAdd, name, productId, source, taskUUID } = data
        return (
            <tr key={id} styleName='integration-log-row' onClick={() => changeIntegrationLogId(id)}>
                <td styleName='integration-log-cell'>{id}</td>
                <td styleName='integration-log-cell'>{name}</td>
                <td styleName='integration-log-cell'>{taskUUID}</td>
                <td styleName='integration-log-cell'>{dateAdd}</td>
            </tr>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepIntegrations/IntegrationLogRow.jsx